<template>
  <span class="embeddedVoiceRecorder">
    <audio-recorder
      ref="audioRecorder"
      :time="maxMinutesLength"
      :after-recording="saveRecording"
    />
  </span>
</template>

<script>
import { AudioRecorder } from 'vue-audio-recorder'

export default {
    name: 'EmbeddedVoiceRecorder',
    components: {
        AudioRecorder
    },
    props: {
        maxMinutesLength: { type: Number, required: false, default: 5 },
        filename: { type: String, required: true },
        callbackToSaveRecord: { type: Function, required: true }
    },
    methods: {
        clearRecords() {
            this.$refs.audioRecorder.recordList = []
            this.$refs.audioRecorder.selected = {}
        },
        async saveRecording(record) {
            if (record) {
                const file = new File([record.blob], `${this.filename}.mp3`, { type: 'audio/mp3' })
                this.callbackToSaveRecord(file)
                this.clearRecords()
            }
        }
    }
}
</script>

<style>
  .embeddedVoiceRecorder .ar-content {
    flex-direction: row;
    padding: 0;
    justify-content: center;
  }

  .embeddedVoiceRecorder .ar {
    width: 100%;
    background: transparent;
    box-shadow: none;
  }

  .embeddedVoiceRecorder .ar-content .ar-icon {
    top: 0;
  }

  .embeddedVoiceRecorder .ar-content .ar-icon__lg {
    border-color: #FF6B64 !important;
    fill: #FF6B64 !important;
  }

  .embeddedVoiceRecorder .ar-content .ar-icon--rec {
    fill: #FFF;
  }

  .embeddedVoiceRecorder .ar-content .ar-recorder__stop {
    border-color: rgb(177, 177, 177) !important;
    fill: rgb(138, 138, 138);
    right: -5px;
    top: 0;
  }

  .embeddedVoiceRecorder .ar-content .ar-recorder {
    margin-right: 15px;
    width: 122px;
  }

  .embeddedVoiceRecorder .ar-content .ar-recorder__duration {
    margin: 0;
    display: flex;
    align-items: center;
    font-size: 15pt;
  }

  .embeddedVoiceRecorder .ar-content .ar-player {
    display: none;
  }

  .embeddedVoiceRecorder .ar-content .ar-records {
    display: none;
  }

  .embeddedVoiceRecorder .ar-recorder__time-limit {
    display: none;
  }
</style>
